import { registeredStores } from './persistentStore/persistentStore'

export const loadStores = () =>
  Promise.allSettled(Object.values(registeredStores).map((store) => store.populateStore()))
